import React, { useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { useDispatch, useSelector } from "react-redux";
import { 
  FormControl, 
  Grid, 
  MenuItem, 
  Select, 
  TextField, 
} from "@material-ui/core";
import { getTurnosCtaCtePorGrupo } from '../../../../../actions/turnos/ctaCte';
import { BuscadorParaTurnos } from '../../../../afiliaciones/BuscadorParaTurnos';

const useStyles = makeStyles((theme) => ({
    formControl: {
        marginTop: -15,
        minWidth: 120,
    },
}));

const optionsfecha = {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
};

const formatTime = time => {
    return time.toLocaleString('en-US', { minimumIntegerDigits: 2, useGrouping: false });
}

export const AfiliadoLaboratorio = ({fecha, horariosDemandaValidos = [], idObraSocial, setIdObraSocial, 
  parametrizacionSeleccionada, setParametrizacionSeleccionada, desdeHce, hce}) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  
  const { seleccionado, afiliado } = useSelector((state) => state.afiliacion);
  
  const handleInputChange = (e) => {
      setParametrizacionSeleccionada(e.target.value);
  }

  useEffect(() => {
      if (seleccionado && afiliado.idGrupoFamiliar > 1)
          dispatch(getTurnosCtaCtePorGrupo(afiliado?.idGrupoFamiliar));
  }, [dispatch, afiliado?.idGrupoFamiliar]);

  useEffect(() => {
      if (horariosDemandaValidos.length === 1)
          setParametrizacionSeleccionada(horariosDemandaValidos[0]);
  }, [horariosDemandaValidos]);

  return (
    <Grid container justify="center" direction='row' spacing={4}>
      <Grid item xs={9} 
      >
        <BuscadorParaTurnos
          consultaTurnos={true}
          hideTitle={true}
          laboratorio={true}
          idObraSocial={idObraSocial}
          setIdObraSocial={setIdObraSocial}
          desdeHce={desdeHce}
          onModal={true}
          hce={hce}
        />
      </Grid>
      <Grid item xs={3} 
      >
        <TextField
          margin="normal"
          fullWidth
          disabled={true}
          label="Fecha"
          name="fecha"
          value={new Date(fecha).toLocaleString(
              "es",
              optionsfecha
          )}
          autoComplete="off"
        />
      </Grid>
      <Grid item xs={12} md={10} style={{marginLeft: "auto", marginRight: "auto"}} >
        <FormControl
          className={classes.formControl}
          margin="normal"
          fullWidth={true}
        >
          <Select
            label="Centro Médico / Especialidad / Horario"
            name="idEfHorario"
            fullWidth={true}
            value={parametrizacionSeleccionada}
            onChange={handleInputChange}
          >
            {horariosDemandaValidos.map((item) => (
              <MenuItem key={item.idEfHorario} value={item}>
                {
                  <span>{`${item.centroMedico.descripcionCentro}`}
                      {` / ${item.especialidad.descripcionEspecialidades}`}
                      {` / Horario: ${formatTime(item.horaDesde)} : ${formatTime(item.minDesde)}`}
                      {` a ${formatTime(item.horaHasta)} : ${formatTime(item.minHasta)}`}</span>
                }
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </Grid>      
    </Grid>          
  )
}
